import React from 'react';

const CountryListing = ({ data, isLoading, searchQuery, fetchError }) => {
    return (
        <div
            className="table-card"
            style={{
                overflowX: 'auto',
                WebkitOverflowScrolling: 'touch',
                background: '#fff',
                borderRadius: '8px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                paddingBottom: '10px'
            }}
        >
            <table className="custom-table" style={{ minWidth: '800px' }}>
                <thead>
                    <tr>
                        <th width="10%" style={{ textAlign: 'center' }}>STT</th>
                        <th width="30%">TÊN QUỐC GIA (VN)</th>
                        <th width="30%">TÊN QUỐC GIA (EN)</th>
                        <th width="15%" style={{ textAlign: 'center' }}>MÃ</th>
                        <th width="15%">CHÂU LỤC</th>
                    </tr>
                </thead>
                <tbody>
                    {isLoading ? (
                        <tr>
                            <td colSpan="5" style={{ textAlign: 'center', padding: '60px', color: '#003399' }}>
                                <i className="fa-solid fa-circle-notch fa-spin" style={{ fontSize: '35px', marginBottom: '15px', display: 'block' }}></i>
                                Đang đồng bộ dữ liệu quốc tế
                            </td>
                        </tr>
                    ) : data.length === 0 && !fetchError ? (
                        <tr>
                            <td colSpan="5" style={{ textAlign: 'center', padding: '40px', color: '#888' }}>
                                <i className="fa-solid fa-magnifying-glass" style={{ fontSize: '24px', display: 'block', marginBottom: '10px' }}></i>
                                Không tìm thấy quốc gia nào phù hợp
                            </td>
                        </tr>
                    ) : (
                        data.map((item, index) => (
                            <tr key={item.id}>
                                <td style={{ textAlign: 'center' }}>{index + 1}</td>
                                <td style={{ fontWeight: '600', color: '#333' }}>{item.nameVi}</td>
                                <td style={{ color: '#666' }}>{item.nameEn}</td>
                                <td style={{ textAlign: 'center' }}>
                                    <span style={{ background: '#e3f2fd', color: '#003399', padding: '5px 10px', borderRadius: '4px', fontSize: '13px', fontWeight: 'bold' }}>
                                        {item.id}
                                    </span>
                                </td>
                                <td>{item.region}</td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default CountryListing;